import type {ChoiceQuestionModel} from '../../Question/ChoiceQuestion/ChoiceQuestion.model';
import type {AnswerModelProps} from '../Answer.model';

import {AnswerModel} from '../Answer.model';

export class MultipleChoiceAnswerModel extends AnswerModel<
  string,
  ChoiceQuestionModel
> {
  constructor(props: AnswerModelProps<string, ChoiceQuestionModel>) {
    super(props);
  }

  get isValid(): boolean {
    return Boolean(this.value);
  }

  getScore(question: ChoiceQuestionModel): number {
    if (!this.value) {
      return 0;
    }

    return (
      question.options.find(option => option.id === this.value)?.score ?? 0
    );
  }

  toString(): string {
    if (!this.value) {
      return '';
    }

    return (
      this.question.options.find(option => option.id === this.value)?.title ??
      ''
    );
  }
}
